<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--		-->
	<!-- Info	-->
	<!--		-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="main-group-title">{{ StaffStudentID }} - {{ FullName }}</label>
		</div>
	</div>

	<!--			 -->
	<!-- Info (FYI)  -->
	<!--	 		 -->
	<!-- <div class="main-group-item" style="margin-top:0px">
		<div class="main-group-item-center-padding">
			<label class="main-group-info">Note: </label>
		</div>
	</div> -->

	<!-- 	 	 -->
	<!-- Barcode -->
	<!-- 	 	 -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">CAASS Barcode</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<label class="group-item-label-data">{{ Barcode }}</label>
			</div>
		</div>
	</div>

	<!-- 	 -->
	<!-- UID -->
	<!-- 	 -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">UID</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<label class="group-item-label-data">{{ UID }}</label>
			</div>
		</div>
	</div>

	<!--  	   	 	     -->
	<!-- Status Selector -->
	<!-- 			     -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Status</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedBarcodeStatusSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedBarcodeStatus"
					(ngModelChange)="onStatusChange($event)"
				>
					<option *ngFor="let r of lstBarcodeStatusItems" [ngValue]="r">
						{{ r.IDStatusDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
